import { createServerFn } from "@tanstack/react-start";
import { readErrorPreview, readPostPreview, readUiKit } from "./previews.server";
import { siteContext } from "./site.server";

/** The owner's preview of the 404 or 500 page. */
export const loadErrorPreview = createServerFn({ method: "GET" })
  .validator((input: unknown) => Number(input))
  .handler(async ({ data: status, context }) =>
    readErrorPreview(await siteContext(context), status),
  );

/** Customize's sample of a kind of post. */
export const loadPostPreview = createServerFn({ method: "GET" })
  .validator((input: unknown) => (typeof input === "string" ? input.slice(0, 40) : ""))
  .handler(async ({ data: kind, context }) => readPostPreview(await siteContext(context), kind));

/** The site UI kit gallery, on development servers. */
export const loadUiKit = createServerFn({ method: "GET" }).handler(async ({ context }) =>
  readUiKit(await siteContext(context)),
);
